import axios from 'axios';
import api from './api.service';
import apiRoutes from './api.routes';

const get = async () => api.catchError(async () => {
  const { data } = await axios.get(api.baseRootUrl + apiRoutes.subscriber);
  return data;
});

export default {
  get,
};



// WEBPACK FOOTER //
// ./src/services/company.service.js